import type { WPPost } from '../../services/wordpressApi';

interface MatchResultCardProps {
  match: WPPost['matchData'];
}

const styles = {
  container: {
    background: 'linear-gradient(135deg, rgba(59, 130, 246, 0.1), rgba(37, 99, 235, 0.05))',
    border: '1px solid rgba(59, 130, 246, 0.2)',
    borderRadius: '16px',
    padding: '16px',
    marginBottom: '12px',
  },
  title: {
    fontSize: '12px',
    fontWeight: 600,
    color: '#60a5fa',
    textTransform: 'uppercase' as const,
    letterSpacing: '0.05em',
    marginBottom: '12px',
    display: 'flex',
    alignItems: 'center',
    gap: '6px',
  },
  players: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: '24px',
  },
  player: {
    display: 'flex',
    flexDirection: 'column' as const,
    alignItems: 'center',
    gap: '4px',
    padding: '12px 20px',
    background: '#27272a',
    borderRadius: '12px',
    minWidth: '100px',
    transition: 'all 0.3s ease',
  },
  playerWinner: {
    background: 'linear-gradient(135deg, rgba(34, 197, 94, 0.2), rgba(22, 163, 74, 0.1))',
    border: '1px solid rgba(34, 197, 94, 0.3)',
    boxShadow: '0 0 20px rgba(34, 197, 94, 0.15)',
  },
  name: {
    fontSize: '14px',
    fontWeight: 600,
    color: '#fafafa',
  },
  nameWinner: {
    color: '#4ade80',
  },
  score: {
    fontSize: '28px',
    fontWeight: 800,
    color: '#fafafa',
  },
  scoreWinner: {
    color: '#4ade80',
  },
  vs: {
    fontSize: '12px',
    fontWeight: 600,
    color: '#71717a',
  },
};

export default function MatchResultCard({ match }: MatchResultCardProps) {
  if (!match) return null;

  const { players, winner } = match;

  return (
    <div style={styles.container}>
      <div style={styles.title}>
        🏆 Kết quả đấu
      </div>
      <div style={styles.players}>
        {players.map((player, index) => {
          const isWinner = winner && player.name === winner;
          return (
            <div key={index}>
              {index > 0 && (
                <span style={styles.vs}>VS</span>
              )}
              <div style={{
                ...styles.player,
                ...(isWinner ? styles.playerWinner : {}),
              }}>
                <span style={{
                  ...styles.name,
                  ...(isWinner ? styles.nameWinner : {}),
                }}>
                  {player.name}
                </span>
                <span style={{
                  ...styles.score,
                  ...(isWinner ? styles.scoreWinner : {}),
                }}>
                  {player.score}
                </span>
                {isWinner && (
                  <span style={{ fontSize: '12px', color: '#4ade80' }}>🏆 Winner</span>
                )}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}
